import { render } from "./form3.vue?vue&type=template&id=73f12511&scoped=true&ts=true"
import script from "./form3.vue?vue&type=script&lang=ts"
export * from "./form3.vue?vue&type=script&lang=ts"

import "./form3.vue?vue&type=style&index=0&id=73f12511&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f12511"]])

export default __exports__